export const ADDRESS_BOOK_ROUTER_BASE = '/crm/address-books';

export const ADDRESS_BOOK_ROUTER = {
  LIST: `${ADDRESS_BOOK_ROUTER_BASE}`,
  CREATE: `${ADDRESS_BOOK_ROUTER_BASE}/create`,
  DETAIL: (id: string) => `${ADDRESS_BOOK_ROUTER_BASE}/${id}/general`,
};
